











































import { defineComponent, onMounted, onUnmounted, ref, getCurrentInstance } from '@vue/composition-api';

import BaseIcon from '@/renderer/components/common/BaseIcon.vue';

import i18n, { i18n_t } from '@/locales/i18n';
import ipc from '@/renderer/scripts/utils/ipc';
import { openATagToDownloadUrl } from '@/renderer/scripts/utils/download/utils';
import { CONSTANT_URL } from '@/renderer/scripts/http';

import '@/renderer/assets/images/Icon/svg/successPay.svg';

export default defineComponent({
  name: 'SurveyResultDialog',
  components: {
    BaseIcon,
  },
  setup() {
    const joinQr = CONSTANT_URL.enterpriseWechat;
    const tips = [i18n_t('产品技术支持'), i18n_t('最新功能动态'), i18n_t('实时优惠福利')];
    const innerShow = ref(false);
    const methods = {
      open() {
        innerShow.value = true;
        ipc.emit(ipc.RENDERER_EVENTS_MAP.FINISH_SURVEY);
        ipc.emit(ipc.RENDERER_EVENTS_MAP.FINISH_MOBILE_SURVEY);
        reporter.report('meeting_message', {
          success: 'show',
        });
      },
      close() {
        innerShow.value = false;
      },
      // response-content-disposition=attachment 会强制下载
      download() {
        openATagToDownloadUrl(`${joinQr}?response-content-disposition=attachment`, 'enterpriseWechat');
      },
    };
    onMounted(() => {
      ipc.on(ipc.RENDERER_EVENTS_MAP.SHOW_USER_SURVEY_RESULT, methods.open);
    });
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.SHOW_USER_SURVEY_RESULT, methods.open);
    });
    return {
      joinQr,
      innerShow,
      tips,
      ...methods,
    };
  },
});
